import styled from '@emotion/styled';
import { Card } from 'antd';

export const CardContainer = styled(Card)({
  marginBottom: '20px',
  borderRadius: '20px 20px',
});
